module.exports = __webpack_public_path__ + "img/friction.adc77f0c.svg";